<template>
  <div class="nkn-home-header">
    <div class="nkn-container">
      <div class="header-text">
        <div class="header-text-title">{{$t("home.header.title")}}</div>
        <div class="header-text-content">{{$t("home.header.desc")}}</div>
        <div class="header-text-btn clearfix">
          <a
            v-if="lang === 'en'"
            class="header-btn header-btn-testnet"
            :href="'/static/doc/NewKindofNetwork_EN.pdf'"
            target="_blank"
          >{{$t("home.header.btn1")}}</a>
          <a
            v-else-if="lang === 'kr'"
            class="header-btn header-btn-testnet"
            :href="'/static/doc/NewKindofNetwork_KR.pdf'"
            target="_blank"
          >{{$t("home.header.btn1")}}</a>
          <a
            v-else
            class="header-btn header-btn-testnet"
            :href="'/static/doc/NewKindofNetwork_ZH.pdf'"
            target="_blank"
          >{{$t("home.header.btn1")}}</a>
          <a
            class="header-btn header-btn-intro"
            :href="$url.HOME_HEADER_LINK.mainnet"
            target="_blank"
          >{{$t("home.header.btn2")}}</a>
        </div>
      </div>
      <div class="header-img">
        <a v-if="lang === 'zh'" target="_blank" href="https://forum.nkn.org/t/ncdn-nkn/1877">
          <img v-lazy="'/static/img/home/nCDN@1x.png'" />
        </a>
        <a
          v-else
          target="_blank"
          href="https://forum.nkn.org/t/introducing-ncdn-new-kind-of-cdn-at-www-ncdn-io/1873"
        >
          <img v-lazy="'/static/img/home/nCDN@1x.png'" />
        </a>
      </div>
    </div>
    <img class="header-background" v-lazy="'/static/img/home/BG-texture@2x.png'" />
    <img class="header-background-media" v-lazy="'/static/img/home/BG-texture@1x.png'" />
  </div>
</template>

<script>
import "swiper/dist/css/swiper.css";
import { swiper, swiperSlide } from "vue-awesome-swiper";
import { mapGetters } from "vuex";

export default {
  components: {
    swiper,
    swiperSlide
  },
  data: function() {
    return {
      notice: true,
      screenWidth: document.body.clientWidth,
      swiperOption: {
        slidesPerView: 1,
        loop: false,
        // 自动播放
        autoplay: {
          delay: 15000,
          disableOnInteraction: false
        },
        pagination: {
          el: ".swiper-pagination",
          clickable: true
        }
      }
    };
  },
  computed: {
    ...mapGetters({
      lang: "getLang"
    })
  },
  mounted() {
    window.onresize = () => {
      return (() => {
        window.screenWidth = document.body.clientWidth;
        this.screenWidth = window.screenWidth;
      })();
    };
  },
  methods: {
    noticeClick: function() {
      this.notice = false;
    }
  }
};
</script>

<style lang="scss" scoped>
@media screen and (max-width: 768px) {
  .nkn-home-header .home-header-notice {
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0 !important;
    height: 6.5rem !important;
  }
  .nkn-home-header .container {
    height: auto !important;
  }
}

.nkn-container {
  @media screen and (max-width: 768px) {
    padding-bottom: 20px;
    flex-direction: column-reverse;
    padding-left: 0;
    padding-right: 0;
    align-items: center;
  }
  max-width: 1200px;
  justify-content: space-between;
  align-items: flex-end;
  width: 100%;
  left: 0;
  right: 0;
  margin-left: auto;
  margin-right: auto;
  padding-left: 75px;
  padding-right: 75px;
  display: flex;
  z-index: 100;
}
.header-background {
  display: block;
  position: absolute;
  bottom: 0;
  justify-self: center;
  align-self: center;
  width: 1200px;
  max-width: 2000px;
  margin-left: auto;
  margin-right: auto;
}

.header-background-media {
  display: none;
  margin-left: auto;
  margin-right: auto;
  position: absolute;
  justify-self: flex-end;
  align-self: center;
  width: 100%;
  min-width: 100%;
  bottom: 0;
}

@media screen and (max-width: 768px) {
  .header-background {
    display: none;
  }
  .header-background-media {
    display: flex;
  }
  .header-img {
    width: 400px;
    margin-bottom: 40px;
    margin-top: 30px;
    .news {
      left: 20px;
    }
    img {
      display: flex;
      align-self: center;
      margin: 0 auto;
      width: 274px;
      height: 182px;
    }
  }
}

.swiper-besides-image-container {
  text-align: center;
  height: 100% !important;
  background: #08074f !important;

  .narwhal-released-spacer {
  }

  img {
    margin-left: auto;
    margin-right: auto;
    width: 100%;
    /*height: 100%;*/
  }
}

.header-img {
  &:hover {
    @include nkn-font-set(14px, #ffffff, 500);
  }
  position: relative;
  .news {
    position: absolute;
    top: 0;
    background-image: url(~@/assets/img/home/news-bg@2x.png);
    background-size: contain;
    background-repeat: no-repeat;
    background-position: left center;
    width: 270px;
    height: 58px;
    @include nkn-font-set(14px, #ffffff, 500);
    display: flex;
    padding-left: 30px;
    padding-top: 16px;
    .icon {
      background-size: contain;
      background-repeat: no-repeat;
      background-image: url(~@/assets/img/home/news-icon@2x.png);
      height: 20px;
      width: 20px;
      margin-right: 10px;
    }
  }
}
.nkn-home-header {
  min-height: 450px;
  padding-top: 50px;
  position: relative;
  background-color: #ffffff;
  display: flex;
  flex-direction: column;

  @media screen and (max-width: 768px) {
    min-height: 500px;
  }

  @media screen and (max-width: 768px) {
    .header-pic {
      margin-top: 20px;

      img {
        width: 345px;
        height: auto;
      }
    }
  }

  .header-text {
    width: 46%;
    max-width: 500px;
    min-width: 450px;
    color: #fff;
    white-space: pre-line;

    @media screen and (max-width: 768px) {
      position: relative;
      width: auto;
      min-width: auto;
      top: auto;
      right: auto;
      margin: 0 20px;
    }

    &-title {
      @include nkn-font-set(20px, #0096ff, 500);
      line-height: 50px;

      @media screen and (max-width: 768px) {
        font-size: 14px;
        width: auto;
        line-height: 20px;
      }
    }

    &-content {
      @include nkn-font-set(14px, #24397d);
      text-align: justify;
      line-height: 1rem;
      margin-top: 0.75rem;
      @media screen and (max-width: 768px) {
        font-size: 12px;
        width: auto;
        line-height: 16px;
      }
    }

    &-btn {
      margin-top: 1.25rem;

      .header-btn {
        width: 8rem;
        height: 2.8rem;
        border-radius: 2rem;
        box-sizing: border-box;
        @include nkn-font-set(0.7rem, currentColor);
        text-align: center;

        &:hover {
          box-shadow: 0 0 0.4rem 0.1rem #1a8fff;
        }

        &-testnet {
          float: left;
          color: #1a8fff;
          border: 0.1rem solid #1791f2;
          line-height: 2.6rem;
          @include nkn-font-set(16px, #1a8fff, 600);
          @media screen and (max-width: 768px) {
            font-size: 12px;
          }
          &:hover {
            background: #1791f2;
          }
        }

        &-intro {
          float: right;
          background: #1791f2;
          color: #fff;
          line-height: 2.8rem;
          @include nkn-font-set(16px, #fff, 600);
          @media screen and (max-width: 768px) {
            font-size: 12px;
          }
          &:hover {
            background: #0570ee;
          }
        }
      }
    }
  }

  .header-pic {
    margin-top: 4rem;
  }

  .home-header-notice {
    width: 100%;
    background: #3752c2;
    position: fixed;
    bottom: 0;
    z-index: 10000;
    height: 4.5rem;
    padding: 0.75rem 2.5rem;

    .notice-cell {
      a {
        text-decoration: underline;
      }

      @media screen and (max-width: 768px) {
        padding: 0 6px !important;
      }
    }

    .header-notice {
      border-radius: 2rem;
      text-align: center;
      height: 2.5rem;
      line-height: 1.5rem;

      &-text {
        height: auto;
        background: #b23030;
        @include nkn-font-set(0.9rem, #fff);

        @media screen and (max-width: 768px) {
          line-height: 16px;
          font-size: 12px;
          padding: 10px;
          transform: scale(0.9);
        }
      }

      &-btn {
        height: auto;
        padding: 0.75rem 2rem;
        background: #253a7e;
        cursor: pointer;
        @include nkn-font-set(1.2rem, #fff);
        transition: all 0.2s;

        @media screen and (max-width: 768px) {
          height: 36px;
          line-height: 36px;
          font-size: 12px;
          padding: 0;
        }

        &:hover {
          background: #364a8e;
        }

        &:active {
          background: #364a8e;
        }
      }
    }
  }

  .slide-fade-leave-active {
    transition: all 0.5s cubic-bezier(1, 0.5, 0.8, 1);
  }

  .slide-fade-leave-to {
    transform: translateX(10px);
    opacity: 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/home/nknHomeHeader.vue